/*global Modernizr, console, compare_info, empty_template, firm_template, convertToDom, templater */
/*jslint browser:true */

(function() {
  'use strict';

  var clear_compare = document.querySelector('.js-clear-compare');
  if(clear_compare) {
    clear_compare.addEventListener('click', (e) => {
      e.preventDefault();

      deleteCookie('attorney_compare');

      window.location = '/';
    });
  }

  var comparison_bar = document.getElementById('comparison-bar');

  if(comparison_bar) {
      var bar_grid = comparison_bar.querySelector('.grid'),
          bar_buttons = bar_grid.querySelector('.buttons'),
          trigger_count = comparison_bar.querySelector('h5 span'),
          trigger_remove = comparison_bar.querySelectorAll('.remove'),
          attorney_compares = document.querySelectorAll('.compare'),
          trigger_clear = comparison_bar.querySelector('.clear');

    if(trigger_clear) {
      trigger_clear.addEventListener('click', (e) => {
        e.preventDefault();

        deleteCookie('attorney_compare');

        comparison_bar.classList.remove('show');
        trigger_count.textContent = '0';

        var firms = bar_grid.querySelectorAll('.firm');
        if(firms) {
          firms.forEach((firm) => {
            firm.remove();
            bar_grid.insertBefore(convertToDom(empty_template), bar_buttons);
          });
        }

        var checked_compares = document.querySelectorAll('.compare input:checked');
        if(checked_compares) {
          checked_compares.forEach((compare) => {
            compare.checked = false;
          });
        }
      });
    }

    if(trigger_remove) {
      trigger_remove.forEach((trigger) => {
        attach_close(trigger.parentNode);
      });
    }

    if(attorney_compares) {
      attorney_compares.forEach((attorney_compare) => {
        attorney_compare.addEventListener('click', (e) => {
          e.preventDefault();

          var compare = getCompare(),
              firm_checkbox = attorney_compare.querySelector('input'),
              checked = firm_checkbox.checked,
              firm_id = firm_checkbox.value;

          if(!checked) {
            if(compare.length < 4) {
              compare.push(firm_id);

              firm_checkbox.checked = true;

              var first_empty_block = bar_grid.querySelector('.empty');

              var new_firm_block = convertToDom(firm_template(compare_info[firm_id]));

              attach_close(new_firm_block);

              bar_grid.insertBefore(new_firm_block, first_empty_block);

              first_empty_block.remove();
            }
          } else {
            var firm_index = compare.indexOf(firm_id);
            delete compare[firm_index];

            firm_checkbox.checked = false;

            var firm_block = bar_grid.querySelectorAll('.firm')[firm_index];
            firm_block.remove();

            bar_grid.insertBefore(convertToDom(empty_template), bar_buttons);
          }

          updateCompare(compare);
        });
      });
    }
  }

  function attach_close(elem) {
    elem.addEventListener('click', (e) => {
      e.preventDefault();

      var compare = getCompare(),
          firm_id = elem.getAttribute('data-firm'),
          firm_index = compare.indexOf(firm_id);

      delete compare[firm_index];
      elem.remove();

      var firm_card_checkbox = document.querySelector('input[value="' + firm_id + '"]');
      if(firm_card_checkbox) {
        firm_card_checkbox.checked = false;
      }

      bar_grid.insertBefore(convertToDom(empty_template), bar_buttons);

      updateCompare(compare);
    });
  }

  function getCompare() {
    var compare = getCookie('attorney_compare');

    if(compare !== '') {
      compare = compare.split(',');
    } else {
      compare = [];
    }

    return compare;
  }

  function updateCompare(compare) {
    compare = compare.filter((v) => { return v !== ''; });
    trigger_count.textContent = compare.length;

    if(compare.length > 0) {
      comparison_bar.classList.add('show');
    } else {
      comparison_bar.classList.remove('show');
    }

    setCookie('attorney_compare', compare.join(','));
  }

  function setCookie(name, value) {
    var expires = "";
    var date = new Date();
    date.setTime(date.getTime() + (7*24*60*60*1000)); // 7 Days
    expires = "; expires=" + date.toUTCString();
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  }

  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)===' ') {
        c = c.substring(1,c.length);
      }
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length,c.length);
      }
    }
    return '';
  }

  function deleteCookie(name) {
    document.cookie = name + '=; Max-Age=-99999999; path=/';
  }
}());
